import React from 'react'

function client() {
  return (
    <div>client</div>
  )
}

export default client